module.exports = __webpack_public_path__ + "static/hv10Logo-24a59f8ee93f3c3927c372e79eb6392b.png";